<div class="form-group">
  <small>{{label}}</small>

  <ng-container *ngIf="controlName">
    <input [readonly]="isDisabled" 
    [ngClass]="{'form-control form-control-sm': true , 'bg-red': isValidationError}"
    placeholder={{placeholder}}
           [(ngModel)]="model[bindValue]"
           (ngModelChange)="ModelChange()"
           [required]="isRequired"
           [minLength]="minLength"
           [maxLength]="maxLength"
           [formControl]="controlName"
           (keyup.enter)="onKeyUp()">
  </ng-container>

  <ng-container *ngIf="!controlName">
    <input [readonly]="isDisabled" 
           [ngClass]="{'form-control form-control-sm': true , 'bg-red': isValidationError}"
           placeholder={{placeholder}}
           [(ngModel)]="model[bindValue]"
           (ngModelChange)="ModelChange()"
           [required]="isRequired"
           [minLength]="minLength"
           [maxLength]="maxLength"
           (keyup.enter)="onKeyUp()"
           >
  </ng-container>

  <small *ngIf="isRequired" class="text-muted validator-information">Pole wymagane</small>
  <small *ngIf="minLength && maxLength && minLength!==maxLength" class="text-muted validator-information"> Długość min: {{minLength}} / max: {{maxLength}}</small>
  <small *ngIf="minLength && maxLength && minLength===maxLength" class="text-muted validator-information"> Długość: {{minLength}}</small>
  <small *ngIf="minLength && !maxLength " class="text-muted validator-information"> Minimalna długość: {{minLength}}</small>
  <small *ngIf="!minLength && maxLength && maxLength !== 1024 " class="text-muted validator-information"> Maksymalna długość: {{maxLength}}</small>
</div>

